/** Lot Biography — find a lot by number, or browse a crop variety's lots. */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import { LotFinderPage } from "@/features/inventory/lots/lot-biography-page";
import { useDeskFacility } from "@/features/warehouse/route-helpers";

const search = z.object({
  view: z.enum(["lot", "variety"]).optional().catch(undefined),
  q: z.string().optional().catch(undefined),
  crop: z.number().int().positive().optional().catch(undefined),
  variety: z.number().int().positive().optional().catch(undefined),
  stage: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/_app/warehouse/lot-biography/")({
  validateSearch: search,
  beforeLoad: () => {
    // Quality ▸ Lot Biography opens it for QA roles too (qc.lot_biography, 2026-10-16).
    const { can } = useAuth.getState();
    if (!can("inventory.view") && !can("qc.lot_biography"))
      throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <LotFinderPage
      facilityId={useDeskFacility() ?? undefined}
      search={s}
      onSearch={(next) =>
        void navigate({
          search: (prev) => ({ ...prev, ...next }),
          replace: true,
        })
      }
    />
  );
}
